var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    d: "  M49.286,4.542c15.273,0,27.655,12.38,27.655,27.654c0,1.694-0.161,3.305-0.447,4.971C74.666,47.242,56.785,82.136,51.687,93.77  c-0.427,0.973-1.334,1.565-2.396,1.564c-1.063-0.001-1.969-0.596-2.393-1.569c-4.911-11.271-25.267-51.852-25.267-61.568  C21.631,16.922,34.012,4.542,49.286,4.542L49.286,4.542z M49.286,19.953c-6.762,0-12.243,5.481-12.243,12.244  c0,6.762,5.481,12.244,12.243,12.244c6.762,0,12.243-5.482,12.243-12.244C61.529,25.434,56.048,19.953,49.286,19.953z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.b0463868eb7c2be2ac3ede352b906c11.svg";
export { ForwardRef as ReactComponent };